import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const Invoice = () =>{
 return(
   <DocumentDetails documentType={'invoices'} keyAccess={'IDDocument'} title={'Invoice'} exportDataToExcelName={'invoice Document'} analysefrom={'invoice'} deleteText={'invoice'} modelName={'doc-ai'} webSocketName = {'invoice'} />
 )
};
export default Invoice;